module.exports = __webpack_public_path__ + "8f59d4624a5eae53faa56cccfc3a4131.png";